import { api } from "./api_core";

export const zeriApi = {
  // 择日相关接口 (预留)
};